import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFullBoard = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 1024 768",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsxs("g", {
		fill: "#fff",
		children: [/* @__PURE__ */ _jsx("path", {
			d: "m35.419 244.36c0 49.516 44.49 235.17 55.648 278.24 8.245 31.823 20.811 64.568 35.414 92.747 19.265 37.179 64.926 49.83 101.18 58.577 52.392 12.637 113.08 14.643 166.94 14.643 50.707 0 106.66-15.83 155.3-27.564 11.91-2.872 43.024-6.508 54.829-9.762 45.895-12.653 69.397-24.001 118.7-35.894 33.529-8.087 68.606-28.901 96.122-48.815 34.103-24.68 60.854-55.51 86-87.865 5.061-6.508 10.119-13.016 15.178-19.524 19.406-24.968 30.354-66.798 30.354-97.63 0-37.49 5.128-65.73-10.118-102.51-15.009-36.207-48.047-61.005-75.885-87.866-33.099-31.938-58.514-64.688-97.648-83.568-39.909-19.254-97.658-20.02-141.65-34.17-55.451-17.835-122.48-23.822-180.59-23.822h-131.53c-45.126 0-40.415 6.8879-83.638 15.229-30.513 5.8881-194.6 141.99-194.6 199.55z",
			fillRule: "evenodd",
			strokeWidth: .814
		}), /* @__PURE__ */ _jsxs("g", {
			stroke: "#000",
			children: [/* @__PURE__ */ _jsxs("g", {
				strokeLinecap: "round",
				strokeMiterlimit: 0,
				strokeWidth: 11.3,
				children: [/* @__PURE__ */ _jsx("path", { d: "m737.06 543.65c-104.63 118.78-286.06 136.88-413.09 41.21-127.04-95.666-155.33-271.69-64.417-400.8 90.912-129.11 269.28-166.21 406.14-84.484" }), /* @__PURE__ */ _jsx("path", { d: "m336.53 205.06c66.616-78.344 179.71-101.66 273.1-56.309 93.394 45.353 142.54 147.46 118.68 246.56-23.858 99.108-114.45 169.17-218.77 169.19" })]
			}), /* @__PURE__ */ _jsxs("g", {
				strokeWidth: 5.883,
				children: [/* @__PURE__ */ _jsxs("g", {
					fillOpacity: .75,
					fillRule: "evenodd",
					children: [/* @__PURE__ */ _jsx("path", { d: "m782.27 218.26l0.8911-75.168s-1.3367-15.034 11.146-15.034c12.038 0 9.808 15.034 9.808 15.034l-0.4456 75.168s-1.3384 7.5172 8.9169 7.9594c10.254 0.4422 8.4695-8.4015 8.4695-8.4015l-0.4456-73.842s-0.89111-15.919 9.8098-15.919c10.699 0 8.4695 16.361 8.4695 16.361v75.61s3.3445 6.5218 10.701 6.1906c7.3565-0.3329 8.5814-6.3016 8.805-6.136l1.0031-75.223s0-15.919 9.3624-16.361c9.3626-0.44222 9.3626 16.361 9.3626 16.361l-0.4456 79.59s4.9922 64.3-25.489 68.624c-26.98 3.8277 10.645 228.68 0.58539 235.37-9.5162 6.3289-11.898 7.442-20.815 7.8842-8.9169 0.4422-17.64-2.7283-23.336-9.134-10.495-11.802 22.861-232.58 2.6875-235.43-26.286-3.7219-29.487-73.944-29.041-73.502z" }), /* @__PURE__ */ _jsx("path", { d: "m88.69 170.71c12.038-22.552 36.559-26.244 47.258-26.244 10.701 0 39.526 2.5148 47.705 28.013 8.2843 25.823 4.5467 143.89-25.935 148.21-26.98 3.8278 10.645 228.68 0.58539 235.37-9.5162 6.3289-11.898 7.4421-20.815 7.8843-8.9169 0.4422-16.757-1.0039-22.454-7.4096-10.495-11.802 21.978-231.72 1.805-234.57-26.286-3.7219-40.188-128.71-28.15-151.26z" })]
				}), /* @__PURE__ */ _jsx("path", {
					d: "m137.34 172.56c11.079-2.3416 21.9 7.5211 27.989 25.51 6.0883 17.988 6.4088 41.045 0.82907 59.636s-16.111 29.555-27.24 28.36",
					strokeLinecap: "round"
				})]
			})]
		})]
	})]
});
const ForwardRef = forwardRef(SvgFullBoard);
export { ForwardRef as ReactComponent };
